import { CollectionDetailEntity } from "./CollectionDetailEntity"
import { CollectionHeaderEntity } from "./CollectionHeaderEntity"

export interface CollectionDetailSearchCriteria {

    allRows: CollectionHeaderEntity[],
    selectRows: CollectionHeaderEntity[],
    dtl: CollectionDetailEntity | null,
    delDtlIds: number[] | null,
    observation: string | null,
    dummyKeys: string[] | null,
    allDtls: CollectionDetailEntity[],

    [key: string]: string | boolean | number | null | Object | undefined
}

export const EMPTY_COLLECTION_DTL_SEARCH_CRITERIA: CollectionDetailSearchCriteria = {
    allRows: [],
    selectRows: [],
    dtl: null,
    unPaidHdrList: null,
    delDtlIds: null,
    observation: null,
    dummyKeys: null,
    allDtls: []
}
